<template>
    <div>
        <div class="d-block grey lighten-4 d-flex justify-space-between">
            <div style="width:70%">
                <div class="pa-3">
                    <v-tabs v-model="tab" background-color="transparent">
                        <v-tab v-for="(item, index) in ['Completed', 'Overdue', 'Watch Overdue', 'Lates', 'Attendance']" :key="index" style="background-color: transparent;" :disabled="loading || latesLoading || worklogLoading">
                            {{ item }}
                        </v-tab>
                    </v-tabs>
                </div>
            </div>
            <div class="d-flex justify-center align-center pt-4" style="width:30%">
                <round-circle-rate :value="rate" :size="100" :width="20"></round-circle-rate>
                <v-btn v-if="$router.currentRoute.params.id" color="primary" class="ml-5" @click="appraiseDialog = true">appraise</v-btn>
            </div>
        </div>
        <div class="grey lighten-4">
            <div class="d-flex align-center pa-4">
                <v-btn color="black lighten-2" text class="btn-filter mr-5" @click="filterOpened = !filterOpened" :disabled="taskType === 'lates' || taskType === 'attendance'">Filters <v-icon right>$filter</v-icon></v-btn>
                <div>
                    <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        hide-details
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="month"
                                :disabled="loading"
                                label="Month"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                outlined
                                dense
                                hide-details
                            />
                        </template>
                        <v-date-picker
                            type="month"
                            v-model="month"
                            no-title
                            @input="menu = false"
                            @change="getTasksDebounce"
                        />
                    </v-menu>
                </div>
            </div>
            <v-expand-transition>
                <v-card v-show="filterOpened" elevation="0" class="px-5 transparent" height="auto" style="width: 100%;" :disabled="loading">
                    <v-row>
                        <v-col xs-3 class="align-flex-start" v-for="(filters, index) in filterLayout" :key="index">
                            <v-flex class="d-flex mb-5" v-for="filterItem in filters" :key="filterItem.title">
                                <v-select
                                    multiple
                                    v-model="filterOptions[filterItem.data]"
                                    :items="metaData[filterItem.data]"
                                    item-text="value"
                                    item-value="id"
                                    :label="filterItem.title"
                                    :placeholder="'Select ' + filterItem.title.substr(0, filterItem.title.length - 1)"
                                    dense
                                    outlined
                                    lighten-1
                                    class="ml-2"
                                    style="width: 100%;"
                                    :class="filterItem.data === 'taskTemplates' && 'text-uppercase'"
                                    v-if="!filterItem.autocomplete"
                                >
                                    <template v-slot:selection="{ item, index }">
                                        <span v-if="index === 0" class="selection-text-style">{{ filterItem.type === 'arr' ? item : item.value}}</span>
                                        <span
                                            v-if="index === 1"
                                            class="grey--text caption"
                                        >(+{{ filterOptions[filterItem.data].length - 1 }} others)</span>
                                    </template>
                                </v-select>
                                <v-autocomplete
                                    v-else
                                    multiple
                                    v-model="filterOptions[filterItem.data]"
                                    :items="metaData[filterItem.data]"
                                    item-text="value"
                                    item-value="id"
                                    dense
                                    outlined
                                    lighten-1
                                    :search-input.sync="searchInputAutocomplete[filterItem.typeAutocomplete]"
                                    @change="changeOption(filterItem.typeAutocomplete)"
                                    class="ml-2"
                                    style="width: 100%;"
                                    :class="filterItem.data === 'taskTemplates' && 'text-uppercase'"
                                    :label="filterItem.title"
                                    :placeholder="'Select ' + filterItem.title.substr(0, filterItem.title.length - 1)"
                                >
                                    <template v-slot:selection="{ item, index }">
                                        <span v-if="index === 0" class="selection-text-style">{{ filterItem.type === 'arr' ? item : item.value}}</span>
                                        <span
                                            v-if="index === 1"
                                            class="grey--text caption"
                                        >(+{{ filterOptions[filterItem.data].length - 1 }} others)</span>
                                    </template>
                                    <template v-slot:item="{ item, attrs, on }" v-if="filterItem.data === 'taskTemplates'">
                                        <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                                            <v-list-item-action>
                                                <v-checkbox :input-value="active"></v-checkbox>
                                            </v-list-item-action>
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    <span class="text-uppercase">{{ item.value }}</span>
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </template>
                                </v-autocomplete>
                            </v-flex>
                        </v-col>
                    </v-row>
                </v-card>
            </v-expand-transition>
        </div>
        <div>
            <div v-if="taskType === 'completed'" style="position: relative">
                <v-data-table
                    :loading="loading"
                    :headers="headers"
                    :items="tasks"
                    :options.sync="options"
                    :items-per-page="options.itemsPerPage"
                    :server-items-length="totalItems"
                    no-data-text="No tasks"
                    :footer-props="{
                        'show-current-page': true,
                        'show-first-last-page': true,
                        'items-per-page-options': [10,20,50]
                    }"
                >
                    <template v-slot:body="{ items }">
                        <template v-if="items.length">
                            <tr :key="item.id" v-for="item of items" :class="item.id ? 'specialSpacing' : 'noProductsContainer'" @click="item.id ? openTaskHandler(item.id, tasks) : null">
                                <template v-if="item.id">
                                    <td>
                                        {{ item.title.toUpperCase() }}
                                    </td>
                                    <td>
                                        <app-due-date-circle v-if="item.completedOn" :showCircle="false" :date="item.completedOn" ></app-due-date-circle>
                                    </td>
                                    <td>
                                        <app-due-date-circle v-if="item.dueDate" :showCircle="false" :date="item.dueDate" ></app-due-date-circle>
                                    </td>
                                    <td>
                                        {{ item.category }}
                                    </td>
                                    <td>
                                        {{ item.clinic }}
                                    </td>
                                    <td>
                                        {{ item.interval }}
                                    </td>
                                    <template v-if="taskType === 'watchOverdue'">
                                        <td>
                                            {{ item.employee }}
                                        </td>
                                        <td>
                                            {{ item.role }}
                                        </td>
                                    </template>
                                    <td>
                                        <v-icon>{{ item.appraisalStatus === APPRAISALS_VALUES.CORRECT ? '$happyFace' : '' }}</v-icon>
                                        <v-icon>{{ item.appraisalStatus === APPRAISALS_VALUES.INCORRECT ? '$sadFace' : '' }}</v-icon>
                                    </td>
                                </template>
                                <template v-else>
                                    <td class="noProductsTitle">No appraisals</td>
                                </template>
                            </tr>
                        </template>
                        <template v-else>
                            <tr>
                                <td :colspan="headers.length"></td>
                            </tr>
                        </template>
                    </template>
                </v-data-table>
                <div class="updatedInfo">
                    <p>Realtime data</p>
                </div>
            </div>
            <div v-if="taskType === 'overdue'" style="position: relative">
                <v-data-table
                    :loading="loading"
                    :headers="headers"
                    :items="tasks"
                    :options.sync="options"
                    :items-per-page="options.itemsPerPage"
                    :server-items-length="totalItems"
                    no-data-text="No tasks"
                    :footer-props="{
                        'show-current-page': true,
                        'show-first-last-page': true,
                        'items-per-page-options': [10,20,50]
                    }"
                >
                    <template v-slot:body="{ items }">
                        <template v-if="items.length">
                            <tr :key="item.id" v-for="item of items" :class="item.id ? 'specialSpacing' : 'noProductsContainer'" @click="item.id ? openTaskHandler(item.id, tasks) : null">
                                <template v-if="item.id">
                                    <td>
                                        {{ item.title.toUpperCase() }}
                                    </td>
                                    <td>
                                        <app-due-date-circle v-if="item.completedOn" :showCircle="false" :date="item.completedOn" ></app-due-date-circle>
                                    </td>
                                    <td>
                                        <app-due-date-circle v-if="item.dueDate" :showCircle="false" :date="item.dueDate" ></app-due-date-circle>
                                    </td>
                                    <td>
                                        {{ item.category }}
                                    </td>
                                    <td>
                                        {{ item.clinic }}
                                    </td>
                                    <td>
                                        {{ item.interval }}
                                    </td>
                                    <template v-if="taskType === 'watchOverdue'">
                                        <td>
                                            {{ item.employee }}
                                        </td>
                                        <td>
                                            {{ item.role }}
                                        </td>
                                    </template>
                                    <td>
                                        <v-icon>{{ item.appraisalStatus === APPRAISALS_VALUES.CORRECT ? '$happyFace' : '' }}</v-icon>
                                        <v-icon>{{ item.appraisalStatus === APPRAISALS_VALUES.INCORRECT ? '$sadFace' : '' }}</v-icon>
                                    </td>
                                </template>
                                <template v-else>
                                    <td class="noProductsTitle">No appraisals</td>
                                </template>
                            </tr>
                        </template>
                        <template v-else>
                            <tr>
                                <td :colspan="headers.length"></td>
                            </tr>
                        </template>
                    </template>
                </v-data-table>
                <div class="updatedInfo">
                    <p>Realtime data</p>
                </div>
            </div>
            <div v-if="taskType === 'watchOverdue'" style="position: relative">
                <v-data-table
                    :loading="loading"
                    :headers="headers"
                    :items="tasks"
                    :options.sync="options"
                    :items-per-page="options.itemsPerPage"
                    :server-items-length="totalItems"
                    no-data-text="No tasks"
                    :footer-props="{
                        'show-current-page': true,
                        'show-first-last-page': true,
                        'items-per-page-options': [10,20,50]
                    }"
                >
                    <template v-slot:body="{ items }">
                        <template v-if="items.length">
                            <tr :key="item.id" v-for="item of items" :class="item.id ? 'specialSpacing' : 'noProductsContainer'" @click="item.id ? openTaskHandler(item.id, tasks) : null">
                                <template v-if="item.id">
                                    <td>
                                        {{ item.title.toUpperCase() }}
                                    </td>
                                    <td>
                                        <app-due-date-circle v-if="item.completedOn" :showCircle="false" :date="item.completedOn" ></app-due-date-circle>
                                    </td>
                                    <td>
                                        <app-due-date-circle v-if="item.dueDate" :showCircle="false" :date="item.dueDate" ></app-due-date-circle>
                                    </td>
                                    <td>
                                        {{ item.category }}
                                    </td>
                                    <td>
                                        {{ item.clinic }}
                                    </td>
                                    <td>
                                        {{ item.interval }}
                                    </td>
                                    <template v-if="taskType === 'watchOverdue'">
                                        <td>
                                            {{ item.employee }}
                                        </td>
                                        <td>
                                            {{ item.role }}
                                        </td>
                                    </template>
                                    <td>
                                        <v-icon>{{ item.appraisalStatus === APPRAISALS_VALUES.CORRECT ? '$happyFace' : '' }}</v-icon>
                                        <v-icon>{{ item.appraisalStatus === APPRAISALS_VALUES.INCORRECT ? '$sadFace' : '' }}</v-icon>
                                    </td>
                                </template>
                                <template v-else>
                                    <td class="noProductsTitle">No appraisals</td>
                                </template>
                            </tr>
                        </template>
                        <template v-else>
                            <tr>
                                <td :colspan="headers.length"></td>
                            </tr>
                        </template>
                    </template>
                </v-data-table>
                <div class="updatedInfo">
                    <p>Realtime data</p>
                </div>
            </div>
            <AppraisalLates v-if="taskType === 'lates'" ref="appraisalLates" :date="month" :userId="userId" :latesLoading="latesLoading" @updateLatesLoading="updateLatesLoading($event)"/>
            <AppraisalWorkLog v-if="taskType === 'attendance'" ref="appraisalWorklog" :employeeName="userInfo.firstName || 'User Name'" :date="month" :userId="userId" :worklogLoading="worklogLoading" @updateWorklogLoading="updateWorklogLoading($event)"/>
        </div>
        <employee-task-view :isOpen="isTaskModalOpen" :taskId="taskId" :tasks="tasks" :closeTaskViewModal="closeTaskViewModal"/>
        <v-dialog
            v-model="appraiseDialog"
            width="700"
            @click:outside="appraiseDialog = false"
        >
            <v-form ref="appraiseForm" v-model="appraiseFormValid">
                <v-card>
                    <v-card-title class="headline grey lighten-4 justify-space-between">
                        Appraise {{userInfo.firstName}}
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="6">
                                    <div class="d-flex justify-start">
                                        <v-checkbox hide-details label="Attitude" v-model="appraiseOptions.hasAttitude" class="ma-0"/>
                                    </div>
                                </v-col>
                                <v-col cols="6">
                                    <div class="d-flex justify-start">
                                        <v-checkbox hide-details label="Lates" v-model="appraiseOptions.hasLates" class="ma-0"/>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6">
                                    <div class="d-flex justify-start">
                                        <v-checkbox hide-details label="Sickness" v-model="appraiseOptions.hasSickness" class="ma-0"/>
                                    </div>
                                </v-col>
                                <v-col cols="6">
                                    <div class="d-flex justify-start">
                                        <v-checkbox hide-details label="SynTrain" v-model="appraiseOptions.hasSynTrain" class="ma-0"/>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row class="mb-5">
                                <v-col cols="6">
                                    <div class="d-flex justify-start">
                                        <v-checkbox hide-details label="Appraisal Score" v-model="appraiseOptions.hasAppraisalScore" class="ma-0"/>
                                    </div>
                                </v-col>
                                <v-col cols="6">
                                    <div class="d-flex justify-start">
                                        <v-checkbox hide-details label="Unauthorized abscence" v-model="appraiseOptions.hasUnauthorizedAbsence" class="ma-0"/>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-textarea
                                outlined
                                name="input-7-4"
                                label="Leave a comment *"
                                :rules="[rules.required]"
                                v-model="appraiseOptions.note"
                            />
                        </v-container>
                    </v-card-text>
                    <v-divider/>
                    <v-card-actions class="px-5 py-4">
                        <v-switch
                            v-model="appraiseOptions.isCancelled"
                            class="my-0"
                            hide-details
                            label="Bonus"
                        />
                        <v-spacer/>
                        <v-btn color="primary" class="mx-3" @click="appraiseDialog = false" :disabled="appraiseLoading">Cancel</v-btn>
                        <v-btn color="primary" class="mx-3" @click="setAppraise" :loading="appraiseLoading" :disabled="appraiseLoading">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
    </div>
</template>

<script>
    import config from '@/common/config'
    import RoundCircleRate from '@/components/RoundCircleRate'
    import AppDueDateCircle from '@/components/AppDueDateCircle'
    import { mapGetters, mapActions } from 'vuex'
    import { APPRAISALS_VALUES } from '@/common/constants'
    import selectInputAutocomplete from '../../constatns/selectInputAutocomplete'
    import AppraisalLates from '@/views/appraisal/AppraisalLates'
    import validationRules from '@/common/validationRules'
    import AppraisalWorkLog from '@/views/appraisal/AppraisalWorkLog'

    export default {
        components: {
            AppraisalWorkLog,
            AppraisalLates,
            RoundCircleRate,
            AppDueDateCircle,
            EmployeeTaskView: () => import('../tasks/TaskView')
        },
        props: ['tasks', 'loading', 'rate', 'metaData', 'totalItems', 'defaultDates', 'userId', 'userInfo'],
        data () {
            return {
                rules: { ...validationRules },
                APPRAISALS_VALUES: APPRAISALS_VALUES,
                title: '',
                tab: 0,
                taskType: 'completed',
                paginationTotalVisible: config.paginationTotalVisible,
                options: {
                    itemsPerPage: 10,
                    page: 1,
                    sortBy: ['dueDate'],
                    sortDesc: ['DESC'],
                    mustSort: false,
                    multiSort: false
                },
                filterOpened: false,
                filterOptions: {
                    appraisalStatuses: [],
                    categories: [],
                    clinics: [],
                    intervals: [],
                    taskTemplates: [],
                    employees: [],
                    roles: []
                },
                menu: false,
                month: `${new Date().getFullYear()}-${('0' + (new Date().getMonth() + 1)).slice(-2)}`,
                filteringTimerId: null,
                isTaskModalOpen: false,
                taskId: null,
                searchInputAutocomplete: {
                    [selectInputAutocomplete.taskTemplate]: null,
                    [selectInputAutocomplete.clinics]: null
                },
                latesLoading: false,
                worklogLoading: false,
                appraiseFormValid: false,
                appraiseDialog: false,
                appraiseLoading: false,
                appraiseOptions: {}
            }
        },
        beforeMount: function () {
            this.$router.currentRoute.query.date && (this.month = this.$router.currentRoute.query.date)
        },
        mounted: function () {
            this.resetAppraiseOptions()
        },
        computed: {
            ...mapGetters({
                filterDate: 'getFilterDate',
                getUserActiveGroup: 'getUserActiveGroup'
            }),
            filterLayout () {
                let filterLayout = [
                    [
                        {
                            title: 'Appraisal status:',
                            data: 'appraisalStatuses',
                            model: 'appraisalStatuses',
                            type: 'obj'
                        },
                        {
                            title: 'Clinics:',
                            data: 'clinics',
                            model: 'clinics',
                            type: 'obj',
                            autocomplete: true,
                            typeAutocomplete: selectInputAutocomplete.clinics
                        }
                    ],
                    [
                        {
                            title: 'Task templates:',
                            data: 'taskTemplates',
                            model: 'taskTemplates',
                            type: 'obj',
                            autocomplete: true,
                            typeAutocomplete: selectInputAutocomplete.taskTemplate
                        }
                    ]
                ]
                if (this.taskType === 'watchOverdue') {
                    filterLayout[1].splice(filterLayout[1].length, 0, {
                        title: 'Assignee:',
                        data: 'employees',
                        model: 'employees',
                        type: 'obj',
                        autocomplete: true
                    })
                }
                if (this.taskType === 'lates' || this.taskType === 'attendance') {
                    filterLayout = []
                }
                return filterLayout
            },
            headers () {
                const headers = [
                    {
                        text: 'Task',
                        align: 'left',
                        sortable: true,
                        value: 'Title'
                    },
                    {
                        text: 'Completion Date',
                        align: 'left',
                        sortable: true,
                        value: 'CompletedOn'
                    },
                    {
                        text: 'Due date',
                        align: 'left',
                        sortable: true,
                        value: 'Duedate'
                    },
                    {
                        text: 'Category',
                        align: 'left',
                        sortable: true,
                        value: 'Category'
                    },
                    {
                        text: 'Clinic',
                        align: 'left',
                        sortable: true,
                        value: 'Clinic'
                    },
                    {
                        text: 'Interval',
                        align: 'left',
                        sortable: true,
                        value: 'Interval'
                    },
                    {
                        text: 'Rate',
                        align: 'left',
                        sortable: true,
                        value: 'IsCorrect'
                    }
                ]

                if (this.taskType === 'watchOverdue') {
                    headers.splice(headers.length - 1, 0, {
                            text: 'Assignee',
                            align: 'left',
                            sortable: true,
                            value: 'employee'
                        },
                        {
                            text: 'Roles',
                            align: 'left',
                            sortable: true,
                            value: 'role'
                        })
                }

                return headers
            },
            totalPages: function () {
                return Math.ceil(this.totalItems / this.options.itemsPerPage)
            }
        },
        watch: {
            tab: {
                handler (value) {
                    let task = null
                    switch (value) {
                        case 0 :
                            task = 'completed'
                            break
                        case 1 :
                            task = 'overdue'
                            break
                        case 2 :
                            task = 'watchOverdue'
                            break
                        case 3 :
                            task = 'lates'
                            break
                        case 4 :
                            task = 'attendance'
                            break
                    }
                    this.taskType = task
                    this.options.page = 1
                    this.getTasksDebounce()
                },
                deep: true
            },
            options: {
                handler () {
                    this.getTasksDebounce()
                },
                deep: true
            },
            filterOptions: {
                handler () {
                    this.options.page = 1
                    this.getTasksDebounce()
                },
                deep: true
            },
            getUserActiveGroup () {
                this.getTasksDebounce()
            }
        },
        methods: {
            ...mapActions([
                'setFilteredDate',
                'setEmployeeBonus'
            ]),
            getTasksDebounce () {
                clearTimeout(this.filteringTimerId)
                this.filteringTimerId = setTimeout(this.sentData, 200)
            },
            sentData () {
                const filterOptions = {}
                for (const optionName in this.filterOptions) {
                    if (!Object.prototype.hasOwnProperty.call(this.filterOptions, optionName)) {
                        continue
                    }
                    const filterOptionVal = this.filterOptions[optionName]
                    if (typeof filterOptionVal === 'object' && !Array.isArray(filterOptionVal)) {
                        filterOptions[optionName] = filterOptionVal.value
                    } else {
                        filterOptions[optionName] = filterOptionVal
                    }
                }

                if (this.taskType === 'lates') {
                    this.$refs.appraisalLates.outsideGetTrigger()
                }
                if (this.taskType === 'attendance') {
                    this.$refs.appraisalWorklog.getWorklog()
                }
                if (this.taskType === 'completed' ||
                    this.taskType === 'overdue' ||
                    this.taskType === 'watchOverdue'
                ) {
                    const params = {
                        isOverdue: this.taskType === 'overdue' || this.taskType === 'watchOverdue',
                        Date: this.month,
                        groupId: this.getUserActiveGroup,
                        ...filterOptions,
                        PageSize: this.options.itemsPerPage,
                        PageNumber: this.options.page,
                        sortField: this.options.sortBy[0] || 'id',
                        sortOrder: this.options.sortDesc[0] ? 'DESC' : 'ASC'
                    }
                    this.$emit('getTasks', params, this.taskType === 'watchOverdue')
                }
            },
            openTaskHandler (id, tasks) {
                this.taskId = id
                this.isTaskModalOpen = true
            },
            closeTaskViewModal () {
                this.getTasksDebounce()
                this.isTaskModalOpen = false
            },
            changeOption (typeSearch) {
                this.searchInputAutocomplete[typeSearch] = ''
            },
            updateLatesLoading (value) {
                this.latesLoading = value
            },
            updateWorklogLoading (value) {
                this.worklogLoading = value
            },
            resetAppraiseOptions () {
                this.appraiseOptions = {
                    hasAttitude: false,
                    hasLates: false,
                    hasSickness: false,
                    hasSynTrain: false,
                    hasAppraisalScore: false,
                    hasUnauthorizedAbsence: false,
                    note: '',
                    isCancelled: false
                }
            },
            async setAppraise () {
                this.$refs.appraiseForm.validate()
                if (!this.appraiseFormValid) return
                const queryData = { ...this.appraiseOptions }
                queryData.isCancelled = !this.appraiseOptions.isCancelled
                queryData.Date = this.month
                queryData.employeeId = this.userId
                try {
                    this.appraiseLoading = true
                    await this.setEmployeeBonus(queryData)
                    this.appraiseLoading = false
                    this.appraiseDialog = false
                    await this.$refs.appraiseForm.reset()
                    this.resetAppraiseOptions()
                } catch (e) {
                    this.appraiseLoading = false
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .v-tabs-bar {
        background-color: transparent !important;
    }

    .v-data-table {
        width: 100%;
    }

    .select-item-custom {
        width: 100%;
    }

    .btn-filter {
        svg {
            fill: #000
        }
    }
    .selection-text-style {
        font-size: 13px;
    }
    .expand-transition-enter-active, .expand-transition-leave-active {
        transition: .3s cubic-bezier(.25,.8,.5,1);
    }

    .btn-filter {
        svg {
            fill: #000
        }
    }
    .noProductsContainer {
        height: 50px;

        &:hover {
            background-color: transparent;
        }
    }
    .noProductsTitle {
        border: none;
        position: absolute;
        height: 50px;
        display: flex;
        align-items: center;
        width: 100%;
        left: 0;
        justify-content: center;
    }
    .updatedInfo {
        position: absolute;
        bottom: 0;
        left: 25px;

        p {
            color: rgb(95, 95, 95, 87%);
        }
    }
</style>
